import { render, staticRenderFns } from "./DecisionTargetListTable.vue?vue&type=template&id=313aad52&scoped=true&"
import script from "./DecisionTargetListTable.vue?vue&type=script&lang=js&"
export * from "./DecisionTargetListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313aad52",
  null
  
)

export default component.exports